const getModulePadding = () => `lg:px-8 px-0`;

export default getModulePadding;
